<template>
  <v-dialog
    scrollable
    persistent
    max-width="65vw"
    v-model="configureMessagesDialog"
    :fullscreen="$vuetify.breakpoint.smAndDown">
    <v-card>
      <v-card-title>
        <span class="headline">{{ incentiveApproachType.name }}</span>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text class="pb-0">
        <!--SMS-->
        <v-layout v-if="approach && approach.type == 'INCENTIVE_SMS'" wrap>
          <v-flex xs12>
            <TextareaAutocomplete
              name="sms"
              label="Conteúdo"
              :message="message"
              :variables="variables"
              @message="message = $event" />
            <small>
              <div class="text-xs-right" style="padding: 4px">
                <strong>{{ contentLength + "/160 " + caracterLabel }}</strong>
              </div>
            </small>
          </v-flex>
        </v-layout>

        <!--PUSH-->
        <v-layout wrap v-if="approach && approach.type == 'INCENTIVE_PUSH'">
          <v-flex xs12 class="mb-3">
            <v-text-field
              box
              required
              hide-details
              class="green-input"
              v-model="push.title"
              value="Novo push"
              label="Título*"
              name="push_title" />
          </v-flex>
          <v-flex xs12 class="mb-3">
            <v-select
              box
              required
              hide-details
              label="Link*"
              :items="links"
              v-model="push.link"></v-select>
          </v-flex>
          <v-flex xs12 class="mb-3">
            <TextareaAutocomplete
              name="body"
              label="Conteúdo*"
              :message="push.body"
              :variables="variables"
              @message="push.body = $event" />
          </v-flex>
        </v-layout>

        <!--EMAIL-->
        <v-layout v-if="approach && approach.type == 'INCENTIVE_EMAIL'" wrap>
          <v-flex xs12 class="mb-3">
            <v-text-field
              box
              required
              hide-details
              name="email_subject"
              label="Assunto do email*"
              v-model="email.subject" />
          </v-flex>
          <v-flex xs12 class="mb-3">
            <v-text-field
              box
              required
              hide-details
              type="url"
              size="100"
              name="url_email"
              label="Url do email*"
              v-model="email.template_url">
              <template v-slot:append>
                <v-icon
                  color="primary"
                  :disabled="!isValidHttpUrl(email.template_url)"
                  @click="window.open(`${email.template_url}`, '_blank')"
                  >mdi-code-tags</v-icon
                >
              </template>
            </v-text-field>
          </v-flex>
          <v-flex xs12>
            <v-switch
              hide-details
              class="mb-1 mt-0 pt-0"
              label="Mostrar mais variáveis"
              v-model="switchShow"></v-switch>
          </v-flex>
        </v-layout>

        <!-- WHATSAPP -->
        <v-layout v-if="approach && approach.type == 'INCENTIVE_WHATSAPP'" wrap>
          <v-flex xs12 class="mb-3">
            <initiative-selector
              :value="whatsapp_initiative_id"
              @input="(ev) => (whatsapp_initiative_id = ev)"
              :creditor-id="approach.creditor_id || creditorId"
              scope="INCENTIVE"
            />
          </v-flex>
        </v-layout>

        <!--VARIABLES-->
        <v-flex
          v-if="approach && approach.type !== 'INCENTIVE_WHATSAPP'"
          md12
          class="mb-3"
          style="overflow: auto; border: 1px solid #cccccc">
          <v-layout
            wrap
            align-left
            justify-left
            class="var_container"
            :data-select="variableSelected">
            <v-flex
              lg3
              md4
              sm6
              xs12
              :key="`${index}`"
              v-for="(variable, index) in variables"
              v-show="switchShow ? true : variable.show">
              <v-chip
                class="var_content"
                :disabled="variable.selected"
                v-on:click="varClick(variable.name)">
                <small>
                  <strong>{{ variable.name }}</strong>
                  <br />
                  <small style="margin-top: -2px; font-size: 10px">
                    {{ variable.label }}
                  </small>
                </small>
              </v-chip>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-layout class="pa-2" row wrap>
          <v-select
            box
            clearable
            hide-details
            item-value="id"
            label="Tipo da oferta"
            item-text="description"
            :items="offerTypes"
            v-model="offerId"></v-select>
          <v-spacer></v-spacer>
          <v-btn
            large
            outline
            color="primary"
            style="margin-top: 6px"
            @click="$emit('update:configureMessagesDialog', false)">
            Fechar
          </v-btn>
          <v-btn
            large
            color="primary"
            class="elevation-0"
            style="margin-top: 6px"
            :disabled="!contentValid"
            @click="editItem ? updateData() : addData()">
            Salvar
          </v-btn>
        </v-layout>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import TextareaAutocomplete from "@/components/TextAreaAutocomplete";
import InitiativeSelector from "@/components/selects/InitiativeSelector.vue";


export default {
  components: {
    TextareaAutocomplete,
    InitiativeSelector,
  },
  props: [
    "configureMessagesDialog",
    "approach",
    "creditorId",
    "incentiveApproachType",
    "links",
    "offerTypes",
    "variables",
    "editItemData",
  ],
  data: () => ({
    alert: true,
    message: "",
    push: { title: "Novo push", body: "", link: "$LINK" },
    email: { subject: "", template_url: "", content: "" },
    whatsapp_initiative_id: null,
    switchShow: false,
    offerId: null,
    contentLength: 0,
    editItem: false,
    currentEditItemIndex: null,
    currentEditItemId: null,
    configMce: {
      language: "pt_BR",
      height: "250",
      branding: false,
      language_url: "tinymce-language-pt_BR.js",
      theme: "modern",
      fontsize_formats: "8px 10px 12px 14px 16px 18px 20px 22px 24px 26px 39px 34px",
      plugins: "preview fullpage searchreplace autolink",
      toolbar1: "formatselect fontsizeselect | bold italic strikethrough forecolor backcolor link",
    },
  }),

  watch: {
    configureMessagesDialog(val) {
      if (!val) {
        setTimeout(() => {
          this.offerId = null;
          this.message = "";
          this.push = { body: "", title: "", link: "$LINK" };
          this.email = { content: "", subject: "", template_url: "" };
          this.alert = true;
          this.editItem = false;
          this.currentEditItemIndex = null;
          this.currentEditItemId = null;
          this.whatsapp_initiative_id = null;
        }, 300);
      }
    },

    editItemData(val) {
      if (!val) return;
      const { item, index } = val;
      this.editItem = true;
      this.currentEditItemIndex = index;
      this.currentEditItemId = item.id;

      if (this.$props.approach && this.$props.approach.type == "INCENTIVE_SMS") {
        this.message = item.content;
        this.offerId = item.offer_type_id;
      } else if (this.$props.approach && this.$props.approach.type == "INCENTIVE_PUSH") {
        this.push = Object.assign({}, item);
        this.offerId = item.offer_type_id;
      } else if (this.$props.approach && this.$props.approach.type == "INCENTIVE_EMAIL") {
        this.email = Object.assign({}, item);
        this.offerId = item.offer_type_id;
      } else if (this.$props.approach && this.$props.approach.type == "INCENTIVE_WHATSAPP") {
        this.whatsapp_initiative_id = item.initiative_id;
        this.offerId = item.offer_type_id;
      }
    },
  },

  computed: {
    caracterLabel() {
      return "caracteres";
    },
    variableSelected() {
      if (this.$props.approach && this.$props.approach.type == "INCENTIVE_SMS") {
        let message = this.message;
        for (let i = 0; i < this.variables.length; i++) {
          if (message.includes(this.variables[i].name)) {
            let randomString = Math.random().toString(2).substring(0, this.variables[i].length);
            message = message.replace(this.variables[i].name, randomString);
            this.variables[i]["selected"] = true;
          } else {
            this.variables[i]["selected"] = false;
          }
        }
      } else {
        return false;
      }
    },
    contentValid() {
      let valid = false;
      let array_variables = this.variables || [];
      array_variables = array_variables.map((variable) => String(variable.name));

      if (this.$props.approach && this.$props.approach.type == "INCENTIVE_SMS") {
        this.contentLength = this.message.length;
        if (this.message == "") return false;
        if (this.message.includes(" $ ")) return false;
        if (!this.message.match(/\$LINK[A-Z_0-9]*/)) return false;

        let messageVariables = this.message.matchAll(/^\$([A-Z_0-9]*)/g);
        messageVariables = Array.from(messageVariables);
        messageVariables = messageVariables.map((x) => x[0]);

        for (const idx in messageVariables) {
          if (!array_variables.includes(messageVariables[idx]) || messageVariables[idx] == "$") {
            return false;
          }
        }

        for (const idx in array_variables) {
          if (
            this.message.includes(array_variables[idx].replace("$", " ")) &&
            !this.message.includes(array_variables[idx])
          ) {
            return false;
          }
        }

        let message = this.message;
        (this.variables || []).forEach((e) => {
          if (message.includes(e.name)) {
            let randomString = Math.random().toString(2).substring(0, e.length);
            message = message.replace(e.name, randomString);
            this.contentLength = message.length;
          }
        });

        if (this.contentLength <= 160) valid = true;
      }
      if (this.$props.approach && this.$props.approach.type == "INCENTIVE_PUSH") {
        if (
          this.push.body &&
          this.push.title &&
          this.push.body.length > 0 &&
          this.push.title.length > 0
        )
          valid = true;
      }
      if (this.$props.approach && this.$props.approach.type == "INCENTIVE_EMAIL") {
        if (
          this.email.subject &&
          this.email.subject.length > 0 &&
          this.isValidHttpUrl(this.email.template_url)
        )
          valid = true;
      }

      if (this.$props.approach && this.$props.approach.type == "INCENTIVE_WHATSAPP") {
        if (this.whatsapp_initiative_id) valid = true;
      }

      return valid;
    },
  },

  methods: {
    varClick(value) {
      if (this.$props.approach && this.$props.approach.type == "INCENTIVE_SMS") {
        if (this.message != "") {
          if (this.message[this.message.length - 1] != " ") {
            value = " " + value;
          }
        }
        this.message += value;
      } else if (this.$props.approach && this.$props.approach.type == "INCENTIVE_PUSH") {
        this.push.body = this.push.body + " " + value;
      } else if (this.$props.approach && this.$props.approach.type == "INCENTIVE_EMAIL") {
        this.email.subject = this.email.subject + " " + value;
      }
    },

    isValidHttpUrl(string) {
      let url;
      try {
        url = new URL(string);
      } catch (_) {
        return false;
      }
      return url.protocol === "http:" || url.protocol === "https:";
    },

    addData() {
      let type = "";
      let payload = {};

      if (this.$props.approach && this.$props.approach.type == "INCENTIVE_SMS") {
        type = "sms";
        payload = {
          approach_id: parseInt(this.$props.approach.id),
          content: this.message.trim(),
          flash: false,
          offer_type_id: this.offerId ? this.offerId : null,
        };
      } else if (this.$props.approach && this.$props.approach.type == "INCENTIVE_PUSH") {
        type = "push";
        payload = {
          approach_id: parseInt(this.$props.approach.id),
          title: this.push.title.trim(),
          body: this.push.body.trim(),
          link: this.push.link,
          offer_type_id: this.offerId ? this.offerId : null,
        };
      } else if (this.$props.approach && this.$props.approach.type == "INCENTIVE_EMAIL") {
        type = "email";
        payload = {
          approach_id: parseInt(this.$props.approach.id),
          subject: this.email.subject.trim(),
          template_url: this.email.template_url.trim(),
          content: this.email.content.trim(),
          offer_type_id: this.offerId ? this.offerId : null,
        };
      } else if (this.$props.approach && this.$props.approach.type == "INCENTIVE_WHATSAPP") {
        type = "whatsapp";
        payload = {
          approach_id: parseInt(this.$props.approach.id),
          initiative_id: parseInt(this.whatsapp_initiative_id),
          offer_type_id: this.offerId ? this.offerId : null,
        };
      }
      this.$emit("add", { type, payload });
      this.$emit("update:configureMessagesDialog", false);
    },

    updateData() {
      let type = "";
      let payload = {};

      if (this.$props.approach && this.$props.approach.type == "INCENTIVE_SMS") {
        type = "sms";
        payload = {
          approach_id: parseInt(this.$props.approach.id),
          content: this.message,
          flash: false,
          offer_type_id: this.offerId ? this.offerId : null,
        };
      } else if (this.$props.approach && this.$props.approach.type == "INCENTIVE_PUSH") {
        type = "push";
        payload = {
          approach_id: parseInt(this.$props.approach.id),
          title: this.push.title.trim(),
          body: this.push.body.trim(),
          link: this.push.link,
          offer_type_id: this.offerId ? this.offerId : null,
        };
      } else if (this.$props.approach && this.$props.approach.type == "INCENTIVE_EMAIL") {
        type = "email";
        payload = {
          approach_id: parseInt(this.$props.approach.id),
          subject: this.email.subject.trim(),
          template_url: this.email.template_url.trim(),
          content: this.email.content.trim(),
          offer_type_id: this.offerId ? this.offerId : null,
        };
      } else if (this.$props.approach && this.$props.approach.type == "INCENTIVE_WHATSAPP") {
        type = "whatsapp";
        payload = {
          approach_id: parseInt(this.$props.approach.id),
          initiative_id: parseInt(this.whatsapp_initiative_id),
          offer_type_id: this.offerId ? this.offerId : null,
        };
      }

      this.$emit("update", {
        type,
        payload,
        id: this.currentEditItemId,
        index: this.currentEditItemIndex,
      });

      this.$emit("update:configureMessagesDialog", false);
    },
  },
};
</script>

<style lang="scss" scoped></style>
